<template>
    <div>
        <div class="body">
            <div :class="{'banner':true,'blankBanner':bannerList.length==0}">
                <a-carousel arrows  autoplay>
                    <div
                        slot="prevArrow"
                        class="custom-slick-arrow"
                        style="left: 10px;zIndex: 1"
                        >
                        <a-icon type="left" style="font-size:50px" />
                    </div>
                    <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
                        <a-icon type="right"  style="font-size:50px" />
                    </div>
                    <div v-for="(value,index) in bannerList" :key="index">
                        <img style="cursor:pointer" @click="changeLink(value)" :src="value.banner_img" alt="">
                    </div>
                    
                </a-carousel>
            </div>
            <div class="virtual  fixed">
                <div class="left" style="width:826px;">
                    <h2>> 虚拟仿真实验教学</h2>
                    <h3>virtual simulation experiment teaching</h3>
                    <div class="text">虚拟仿真（Virtual Reality）：仿真（simulation）技术，或称为模拟技术，就是用一个系统模仿另一个真实系统的技术。虚拟仿真实际上是一种可创建和体验虚拟世界（Virtual World）的计算机系统。此种虚拟世界由计算机生成，可以是实现世界的再现，亦可以是构想中的世界，用户可借助视觉、听觉及触觉等多种传感通道与虚拟世界进行自然的交互。</div>
                    <my-button @changePage="changePage('/project')" text="查看更多"></my-button>
                </div>
                <div class="right" style="width:1100px;">
                    <img style="width:762px;margin-top:-62px;" src="../assets/virtual.png" alt="">
                </div>
            </div>
            <!-- <div class="newVr">
                <div class="left">
                    <div class="content">
                        <h2>> VR体验系统</h2>
                        <h3>VR experience system</h3>
                        <div class="text">虚拟仿真（Virtual Reality）：仿真（simulation）技术，或称为模拟技术，就是用一个系统模仿另一个真实系统的技术。虚拟仿真实际上是一种可创建和体验虚拟世界（Virtual World）的计算机系统。此种虚拟世界由计算机生成，可以是实现世界的再现，亦可以是构想中的世界，用户可借助视觉、听觉及触觉等多种传感通道与虚拟世界进行自然的交互。</div>
                        <my-button @changePage="changePage('/project')" text="查看更多" :isWhite="true"></my-button>
                    </div>
                </div>
                <div class="right">
                    <img style="height:100%;" src="../assets/vr.png" alt="">
                </div>
            </div> -->
            <div class="virtual vr">
                <div class="left">
                    <div class="content">
                        <h2>> VR体验系统</h2>
                        <h3>VR experience system</h3>
                        <div class="text">虚拟仿真（Virtual Reality）：仿真（simulation）技术，或称为模拟技术，就是用一个系统模仿另一个真实系统的技术。虚拟仿真实际上是一种可创建和体验虚拟世界（Virtual World）的计算机系统。此种虚拟世界由计算机生成，可以是实现世界的再现，亦可以是构想中的世界，用户可借助视觉、听觉及触觉等多种传感通道与虚拟世界进行自然的交互。</div>
                        <my-button @changePage="changePage('/project')" text="查看更多" :isWhite="true"></my-button>
                    </div>
                </div>
                <div class="right">
                    <img style="height:100%;" src="../assets/vr.png" alt="">
                </div>
            </div>
            <div class="project fixed virtual">
                <div class="left">
                    <h2>> 课程资源</h2>
                    <h3>Curriculum resources</h3>
                    <my-button @changePage="changePage('/project')" text="查看全部课程"></my-button>
                </div>
                <div class="right">
                    <div class="ul">
                        <template  v-for="(item,index) in list">
                            <div :key="index" style="margin-left:32px;margin-right:0;cursor:pointer" @click="changeProduct(item)" class="li">
                                <img :src="apiUrl+item.resource_url" alt="">
                                <p class="title">{{item.resource_name}}</p>
                                <div class="short_detail">{{item.resource_abstract}}</div>
                                <i></i>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="virtual vr" style='position:relative;z-index:2'>
                <div class="left" style="background:#93abb7">
                    <div class="content" >
                        <h2>> 理虚实一体化实验室</h2>
                        <h3>integrated laboratory of theory,virtual reality</h3>
                        <div class="text">智能制造理实一体化综合实验平台是一款由数控机床控制系统、工业机器人控制系统、PLC、HMI触摸屏、总控MES软件、RFID读写器、虚拟仿真实验系统等多个部分组成的综合半实物仿真实验设备。智能制造理实一体化综合实验平台通过实际的操作系统控制仿真场景中虚拟模型进行加工运动，实现智能产线数字孪生。</div>
                        <my-button @changePage="changePage('/solve')" text="查看更多" :isWhite="true"></my-button>
                    </div>
                </div>
                <div class="right">
                    <img style="height:100%;" src="../assets/test.png" alt="">
                </div>
            </div>
            <div class="virtual fixed">
                <div class="left"  style="width:500px;padding-left:0">
                    <h2>> 智能制造 立方学院</h2>
                    <h3>cube college</h3>
                    <div class="text">智能制造立方学院（http://www.accim.com.cn）是由武汉高德信息产业有限公司倾力打造的在线教学与培训云服务平台，是教育部财政部认证备案的省级远程教育培训机构平台。平台基于实际工业应用，聘请国内外领域专家，专注于打造工业机器人、智能制造以及3D打印方向精品在线课程及资源，服务于学校师资培养与教学信息化，同时支持企业高技能型工人及工程师培训，构建智能制造人才培养体系。</div>
                    <my-button @changePage="changePage('cube')"  text="查看更多"></my-button>
                </div>
                <div class="right" style="width:800px;margin-top:-100px;">
                    <img style="width:762px;" src="../assets/cube.png" alt="">
                </div>
            </div>
            <div class="virtual fixed news project">
                <div class="left">
                    <h2>> 新闻中心</h2>
                    <h3>news center</h3>
                    <my-button @changePage="changePage('/aboutNews')" text="查看全部新闻"></my-button>
                </div>
                <div class="right">
                    <div class="ul">
                        <div class="li" @click="changeNews(value)" v-for="(value,index) in news" :key="index"  style="cursor:pointer;">
                            <img :src="apiUrl+value.news_cover.replace(/\/download/g,'public')" alt="">
                            <div class="news_wrap">
                                <p class="title">{{value.news_title}}</p>
                                <div class="short_detail">{{value.news_abstract}}</div>
                                <div class="time">
                                    <i></i>
                                    <span>{{value.publish_time}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="video">
                <div class="wrap">
                    <img src="../assets/poster.png" alt="" @click="playVideo()">
                    <!-- <video ref="myVideo" v-show="isPlay" src="../assets/video.mp4" controls height="277px;"></video> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import myButton from '@/components/button'
import { Carousel,Icon } from 'ant-design-vue';
import {getHomeApi,getNewsListApi,getBannerListApi} from "@/request/api"
export default {
    name:'home',
    created(){
        this.init()
    },
    components:{
        aCarousel:Carousel,
        aIcon:Icon,
        myButton,
    },
    data(){
        return{
            list:[],
            news:[],
            isPlay:false,
            apiUrl:window.g.apiUrl,
            bannerList:[]
        }
    },
    methods:{
        init(){
            this.getToken(getHomeApi,{},res=>{
                this.list=res.data.resource_list.map(
                    item=>({...item,'resource_url':item.resource_url.replace(/\/download/ig,'public')})
                )
            })
            this.getToken(getNewsListApi,{'page':1,'page_size':3},res=>{
                this.news=res.data.data_info
            })
            this.getToken(getBannerListApi,{},res=>{
                this.bannerList=res.data.filter(item=>item.link==1)
            })
                
        },
        onChange() {
        },
        playVideo(){
            this.isPlay=true
            this.$refs.myVideo.play()
        },
        changePage(data){
            if(data=='cube'){
                window.open('http://www.accim.com.cn/newfront/www/index.php', '_blank')
                return
            }
            this.$router.push({path:data})
        },
        changeNews(data){
            this.$router.push({name:'aboutDetailNews',params:{id:data.news_id}})
        },
        changeProduct(data){
            this.$router.push({path:'/project',query:{id:data.product_id}})
        },
        changeLink(data){
            if(data.banner_name){
                window.open(data.banner_name, '_blank')
                return
            }
        }
    }
}
</script>
<style scoped>
.ant-carousel >>> .slick-slide {
  text-align: center;
  overflow: hidden;
}
.body .ant-carousel .custom-slick-arrow{
    height:50px;
}
.ant-carousel >>> .custom-slick-arrow {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
}
.ant-carousel >>> .custom-slick-arrow:before {
  display: none;
}
.ant-carousel >>> .custom-slick-arrow:hover {
  opacity: 0.5;
}

.ant-carousel >>> .slick-slide h3 {
  color: #fff;
}
.banner .custom-slick-arrow{
    width:50px;
}
</style>
<style lang="stylus" scoped>
    .banner
        img 
            width:100%;
    .virtual
        padding:60px 0;
        display:flex;
        justify-content:space-between;
        height:618px;
        .right
            width:600px;
            img 
                width:100%;
        .left
            width:600px;
            padding:30px 60px 0 0;
            
            h2
                font-weight:bold;
                font-size:30px;
                color:#333;
            h3
                font-size:18px;
                color:#999;
            .text
                margin-top:30px;
                text-align:justify;
                color:#7c7c7c;
                line-height:30px;
                
    .vr
        height:539px;
        padding:0;
        .left
            width:826px;
            background:#03b9d9;
            padding-top:60px;
            padding-right:0;
            .content
                width:460px;
                //width:calc((100% - 1200px)/2)
                float:right; 
                padding-right:60px;
                .text
                    color:#fff;
                h2
                    color:#fff
                h3
                    color:#fff

        .right
            width:1100px;
            img 
                width:100%;
    .project
        height:725px;
        padding-top:92px;
        padding-bottom:66px;
        .left
            width:380px;
            padding:30px 0 0;
        .right
            width:auto;
            //图片和文字的公用样式
            .ul
                
                display:flex;
                flex-wrap:wrap;
                .li
                    margin-left:18px;
                    margin-bottom:55px;
                    &:hover
                        p
                            color:#2b83ff;
                    img
                        width:220px;
                        height:148px;
                    p
                        margin:10px 0;
                        width:220px;
                        overflow:hidden;
                        white-space:nowrap;
                        text-overflow:ellipsis;
                        color:#333;
                    .short_detail
                        width:220px;
                        font-size:12px;
                        color:#7c7c7c;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                    i   
                        display:inline-block;
                        width:32px;
                        height:2px;
                        background:#8b8b8b;
            img 
                width:220px;
    .test
        padding-bottom:0;
        .left
            width:50%;
            .content
                width:540px;
                float:right
        .right
            height:450px;
            background:url('../assets/test.png') no-repeat;
    .cube
        height:600px;
        background:#03b9d9;
        .wrap
            width:1200px;
            margin:0 auto;
            display:flex;
            .text
                color:#fff;
            h2
                color:#fff;
            h3
                color:#fff;
    .news
        border-top:1px solid #ddd;
        height:464px;
        .left
            width:150px;
        .right
            .ul
                padding-left:0;
                .li
                    img 
                        width:310px;
                        height:202px;
                    .news_wrap
                        background:#f6f6f6;;
                        p
                            margin-top:0;
                            width:310px;
                            padding:10px 20px 0;
                        .short_detail
                            width:310px;
                            padding:0 20px;
                        .time
                            width:100%;
                            margin-top:10px;
                            display:flex;
                            justify-content:space-between;
                            align-items :center;
                            font-size:12px;
                            color:#7c7c7c;
                            padding:0 20px;
    .video
        background:#e0e2e4;
        height:277px;
        position:relative;
        text-align:center;
        margin-bottom:5px;
        img
            margin:0 auto;
        video 
            position:absolute;
            top:0;
            left:50%;
            transform:translateX(-50%)
    
</style>